import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "py-2 text-sm"
};
import Promotions from "@/modules/competitions/components/divisions/Promotions.vue";
import LeagueTable from "@/modules/competitions/components/divisions/Table/LeagueTable.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'LeagueDivision',
  props: {
    division: null
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(LeagueTable, {
        division: __props.division
      }, null, 8, ["division"]), _createVNode(Promotions, {
        promotions: __props.division.promotions
      }, null, 8, ["promotions"])]);
    };
  }
});